const organization_details = {
    departments: {
        leader: '負責人',
        leaders: '部門負責人',
        led_departments: '負責的部門',
        edit_leaders: '設定負責人',
        add_leader: '新增',
        remove_leader: '移除',
        no_leaders: '未設定負責人',
        local: '本機設定',
        managed_members: '管理範圍內成員',
        leader_scope_hint: '僅可管理負責部門及子部門的成員歸屬。',
        leader_permission_hint: '負責人可管理本部門及子部門的成員歸屬，不能修改組織角色或部門結構。',
        primary_synced: '主部門由飛書同步維護。',
        status_active: '在職',
        status_suspended: '已凍結',
        status_departed: '已離職',
        status_pending: '待啟用',
        search: '搜尋',
        previous_page: '上一頁',
        next_page: '下一頁',
        directory_title: '組織成員',
        member_name: '成員',
        search_members: '按姓名或用戶名稱搜尋',
        include_descendants: '包含子部門',
        no_members: '沒有符合的成員。',
        all_members: '全部成員',
        all_departments: '全部部門',
        edit_member: '編輯部門歸屬',
        add_child: '新增子部門',
        expand_department: '展開{{name}}',
        collapse_department: '收起{{name}}',
        title: '部門',
        description: '管理目前機構的部門及成員歸屬。',
        create: '新增部門',
        edit: '編輯部門',
        name: '部門名稱',
        parent: '上層部門',
        root: '無上層部門',
        id: '部門 ID',
        members: '成員部門歸屬',
        member_id: '成員用戶 ID',
        primary: '主要部門',
        none: '未設定',
        assignments: '部門歸屬記錄',
        no_assignments: '暫無部門歸屬記錄。',
        assignment_hint: '指派本地部門，可設定一個主要部門。通訊錄同步的歸屬由來源維護。',
        empty: '暫無部門。',
        readonly: '你可以檢視部門和自己的歸屬。如需更改，請聯絡機構管理員。',
        load_error: '載入失敗，請重試。',
        mutation_error: '儲存失敗，請檢查權限、成員歸屬及部門層級。',
        loading: '載入中…',
        synced: '通訊錄同步',
        choose: '搜尋部門',
        organizations_title: '機構與部門',
        organizations_description: '選擇機構，檢視或管理其部門。',
        no_organizations: '你尚未加入機構，請聯絡機構管理員。',
        organization: '目前機構',
        choose_organization: '請選擇機構',
        delete_title: '刪除部門',
        delete_description: '確定刪除「{{name}}」？請先移走該部門的成員及子部門。',
    },
    directory: {
        leaders_label: '負責人關係',
        local_department_leader: '本機設定的部門負責人',
        status_active: '在職',
        status_suspended: '已凍結',
        status_departed: '已離職',
        status_pending: '待啟用',
        profiles_label: '來源資料',
        primary_label: '主部門變更',
        deactivated_label: '停用組織身分',
        reactivated_label: '恢復組織身分',
        lifecycle_notice: '保留角色關聯 {{count}} 筆。恢復身分後會恢復原有權限。',
        title: '飛書通訊錄',
        description: '透過飛書連接器，將部門和成員匯入目前機構。',
        identity_notice: '請使用已開啟通訊錄身分同步的連接器。更改既有連接器的身分識別前，需要處理帳戶遷移。',
        connector: '飛書連接器 ID',
        preview: '預覽同步',
        preview_title: '同步預覽',
        preview_description: '請核對通訊錄內容；如內容有變，請重新預覽。',
        import: '確認同步',
        success: '已匯入 {{departments}} 個部門、{{users}} 名成員，新增 {{createdUsers}} 個帳戶。 已移除 {{removedDepartments}} 個部門、{{removedMemberships}} 個組織成員身份、{{removedAssignments}} 條歸屬。',
        failure: '無法讀取或匯入通訊錄。請檢查連接器權限及可見範圍，然後重新預覽。',
        behavior_title: '匯入方式',
        mode: '同步姓名、頭像、部門及主部門。缺失或非在職成員僅停用目前組織身分；保留角色、手動歸屬、全域帳號及其他組織身分。電子郵件、手機僅作來源資料，不綁定為登入憑證。',
        limits: '每次最多 1000 個部門、5000 名用戶、10000 項歸屬；讀取限時 60 秒。內容不完整或超限時拒絕匯入。',
        counts: '{{departments}} 個部門 · {{users}} 名成員',
        departments_label: '部門',
        members_label: '組織成員身份',
        assignments_label: '部門歸屬',
        item: '項目',
        added: '新增',
        updated: '更新',
        removed: '移除',
        cleanup_notice: '同步姓名、頭像、部門及主部門。缺失或非在職成員僅停用目前組織身分；保留角色、手動歸屬、全域帳號及其他組織身分。電子郵件、手機僅作來源資料，不綁定為登入憑證。',
        conflicts_title: '存在 {{count}} 項衝突，暫不能同步。請先處理本地依賴，再重新預覽。',
        removals_title: '移除項目範例（每類最多顯示 20 項）',
        local_child_department: '存在本地子部門',
        unowned_assignment: '存在本地或缺少來源標記的歷史歸屬',
        local_member_roles: '成員具有本地指派的角色',
        unlinked_identity: '通訊錄身份已解除連結',
    },
    page_title: '組織詳細資料',
    delete_confirmation: '刪除後，所有成員將失去他們在此組織的成員資格和角色。此操作無法撤銷。',
    organization_id: '組織 ID',
    settings_description: '組織代表可以訪問您的應用程式的團隊、商業客戶和合作夥伴公司。',
    name_placeholder: '組織的名稱，不需要是唯一的。',
    description_placeholder: '組織的描述。',
    member: '成員',
    member_other: '成員',
    add_members_to_organization: '將成員新增至組織 {{name}}',
    add_members_to_organization_description: '通過搜索姓名、電子郵件、電話或使用者 ID 尋找合適的使用者。現有成員不會顯示在搜尋結果中。',
    add_with_organization_role: '以組織角色添加',
    user: '使用者',
    application: '應用程式',
    application_other: '應用程式',
    add_applications_to_organization: '將應用程式新增至組織 {{name}}',
    add_applications_to_organization_description: '通過搜索應用程式 ID、名稱或描述尋找合適的應用程式。現有應用程式不會顯示在搜尋結果中。',
    at_least_one_application: '至少需要一個應用程式。',
    remove_application_from_organization: '從組織中移除應用程式',
    remove_application_from_organization_description: '移除後，應用程式將失去它在此組織中的關聯和角色。此操作無法撤銷。',
    search_application_placeholder: '按應用程式 ID、名稱或描述搜索',
    roles: '組織角色',
    authorize_to_roles: '授權 {{name}} 存取以下角色：',
    edit_organization_roles: '編輯組織角色',
    edit_organization_roles_title: '編輯 {{name}} 的組織角色',
    remove_user_from_organization: '從組織中移除使用者',
    remove_user_from_organization_description: '移除後，使用者將失去他們在此組織的成員資格和角色。此操作無法撤銷。',
    search_user_placeholder: '按姓名、電子郵件、電話或使用者 ID 搜尋',
    at_least_one_user: '至少需要一名使用者。',
    organization_roles_tooltip: '{{type}} 在此組織中分配的角色。',
    custom_data: '自訂資料',
    custom_data_tip: '自訂資料是一個 JSON 物件，可用於存儲與組織相關的附加資料。',
    invalid_json_object: '無效的 JSON 物件。',
    branding: {
        name: '品牌',
        description: '自訂你的組織級登入體驗。',
        organization_level_sie: '組織級登入體驗',
        organization_level_sie_switch: '啟用組織級登入體驗並設定組織專屬品牌。若停用，將先回退到應用程式級登入，再回退到通用登入體驗。',
        logo: '組織標誌',
        logo_tooltip: '你可以傳遞組織 ID 以在登錄體驗中顯示此標誌；如果在 Omni 登錄體驗設置中啟用了深色模式，則需要使用深色版本的標誌。<a>了解更多</a>',
    },
    jit: {
        title: '即時供應',
        description: '使用者可以通過某些身份驗證方法在首次登錄時自動加入組織並被分配角色。你可以設置即時供應的要求。',
        email_domain: '電子郵件域名供應',
        email_domain_description: '使用已驗證電子郵件地址或通過已驗證電子郵件地址社交登錄的新使用者將自動加入組織。<a>了解更多</a>',
        email_domain_placeholder: '輸入即時供應的電子郵件域名',
        invalid_domain: '無效的域名',
        domain_already_added: '域名已添加',
        sso_enabled_domain_warning: '你輸入了一個或多個與企業 SSO 聯繫的電子郵件域名。使用這些電子郵件的使用者將遵循標準 SSO 流程，除非配置了企業 SSO 供應，否則不會被供應到此組織。',
        enterprise_sso: '企業 SSO 供應',
        no_enterprise_connector_set: '你尚未設置任何企業 SSO 連接器。首先添加連接器以啟用企業 SSO 供應。<a>設置</a>',
        add_enterprise_connector: '添加企業連接器',
        enterprise_sso_description: '首次通過企業 SSO 登錄的新使用者或現有使用者將自動加入組織。<a>了解更多</a>',
        organization_roles: '默認組織角色',
        organization_roles_description: '通過即時供應加入組織時分配角色給使用者。',
    },
    mfa: {
        title: '多因素身份驗證（MFA）',
        tip: '當需要 MFA 時，未配置 MFA 的使用者在嘗試交換組織令牌時將被拒絕。此設置不影響使用者身份驗證。',
        description: '要求使用者配置多因素身份驗證以訪問此組織。',
        no_mfa_warning: '你的租戶未啟用任何多因素身份驗證方法。使用者在啟用至少一種 <a>多因素身份驗證方法</a> 之前將無法訪問此組織。',
    },
};
export default Object.freeze(organization_details);
